/*
 * Journal videos play only while they are on screen.
 *
 * The markup carries preload="none" and no autoplay attribute
 * (snippets/journal-video.liquid), so nothing is fetched until a video actually comes
 * into view. Before this, five autoplaying videos started downloading at once and
 * fought each other for the connection — about 66MB on the Off Press page.
 */
const videos = Array.from(
  document.querySelectorAll('.blog__article-video, .article__video'),
) as HTMLVideoElement[];

if (videos.length && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        const video = target as HTMLVideoElement;

        if (isIntersecting) {
          // preload="none" holds the download back until here
          if (video.preload === 'none') video.preload = 'auto';
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 },
  );

  videos.forEach((video) => observer.observe(video));
} else {
  // no IntersectionObserver: play them all, as before
  videos.forEach((video) => {
    video.preload = 'auto';
    video.play().catch(() => {});
  });
}
